import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState } from '@types'
import { TrackingRows } from '@types'

interface analystTrackState {
  loadingStatus: LoadingState
  message: string
  cases: TrackingRows[]
}

const initialState: analystTrackState = {
  loadingStatus: 'NOT_STARTED',
  message: '',
  cases: []
}

const clubSlice = createSlice({
  name: 'analystTrack',
  initialState,

  reducers: {
    getNewCases: state => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    getAllCases: (state, _action) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    getCasesSuccess: (state, action) => {
      return {
        ...state,
        cases: action.payload,
        loadingStatus: 'SUCCESS'
      }
    },
    patchAnalystInfo: (state, _action) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    getCasesFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearAnalystTrack: _state => {
      return initialState
    }
  }
})

export const analystTrackLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.club.loadingStatus, (state: GlobalState) => state.club.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)
export const selectAnalystNewCases = createDraftSafeSelector(
  [(state: GlobalState) => state.analystTrack.cases],
  cases => {
    const rows: TrackingRows[] = cases.map(person => ({
      ...person,
      id: person._id,
      parentName: person.parentName ? person.parentName : '',
      bankName: person.bank?.toUpperCase(),
      studyDate: person.stages?.studyDate || '',
      office: person.stages?.office || '',
      bank: person.stages?.bank || '',
      bankDocument: person.bankDocument ?? '',
      success: person.stages?.success || '',
      feesOrPayments: person.stages?.feesOrPayments || '',
      comments: person.comments || '',
      isRejected: person?.isRejected || false,
      createdAt: person.createdAt || '2020',
      fee: person.stages?.fee ?? 0,
      payments: person.stages?.payments ?? 0
    }))

    return rows
  }
)

export const { getNewCases, getAllCases, getCasesSuccess, getCasesFailed, patchAnalystInfo } = clubSlice.actions
export default clubSlice.reducer
